import { render, staticRenderFns } from "./GoodDesignAwardFrame.vue?vue&type=template&id=62083c86"
import script from "./GoodDesignAwardFrame.vue?vue&type=script&lang=js"
export * from "./GoodDesignAwardFrame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/home/bazzite/Work/awardapplication/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62083c86')) {
      api.createRecord('62083c86', component.options)
    } else {
      api.reload('62083c86', component.options)
    }
    module.hot.accept("./GoodDesignAwardFrame.vue?vue&type=template&id=62083c86", function () {
      api.rerender('62083c86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/good-design-award/components/GoodDesignAwardFrame.vue"
export default component.exports